import { useEffect } from "react";
import { MotionConfig } from "framer-motion";
import "@/App.css";
import SiteHeader from "@/components/SiteHeader";
import HeroKinetic from "@/components/HeroKinetic";
import EditorialMarquee from "@/components/EditorialMarquee";
import QuickAccess from "@/components/QuickAccess";
import ServicesManifesto from "@/components/ServicesManifesto";
import ResultsSection from "@/components/ResultsSection";
import MaterialsModal from "@/components/MaterialsModal";
import ContactSection from "@/components/ContactSection";
import SiteFooter from "@/components/SiteFooter";
import FloatingWhatsApp from "@/components/FloatingWhatsApp";
import ChatWidget from "@/components/ChatWidget";
import { destroySmoothScroll, initSmoothScroll } from "@/lib/scroll";

function App() {
  useEffect(() => {
    initSmoothScroll();
    return () => destroySmoothScroll();
  }, []);

  return (
    <MotionConfig reducedMotion="user">
      <div className="relative min-h-screen bg-[#07090e] text-slate-100 antialiased">
        <a
          href="#conteudo"
          className="sr-only focus:not-sr-only focus:absolute focus:left-4 focus:top-4 focus:z-[60] focus:rounded-lg focus:bg-brand-tealight focus:px-4 focus:py-2 focus:font-semibold focus:text-slate-950"
        >
          Pular para o conteúdo
        </a>

        <div className="bg-dotgrid pointer-events-none fixed inset-0 z-0 opacity-[0.35]" aria-hidden="true" />

        <div id="conteudo" className="relative z-10">
          <SiteHeader />
          <main>
            <HeroKinetic />
            <EditorialMarquee />
            <QuickAccess />
            <ServicesManifesto />
            <ResultsSection />
            <ContactSection />
          </main>
          <SiteFooter />
        </div>

        <FloatingWhatsApp />
        <ChatWidget />
        <MaterialsModal />
      </div>
    </MotionConfig>
  );
}

export default App;
